import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {L10nModule} from '../../translate';
import {CheckboxSearchInputComponent} from './checkbox-search-input.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        FormsModule
    ],
    declarations: [
        CheckboxSearchInputComponent
    ],
    exports: [
        CheckboxSearchInputComponent
    ]
})
export class CheckboxSearchInputModule {}
